import { Injectable } from '@angular/core';
import { VaultService } from './vault.service';
import { STORED_NOTIFICATIONS } from './vault-service.constants';

export interface StoredNotification {
  id: number;
  title: string;
  body: string;
  category: string;
  receivedAt: Date;
  data: any;
  isRead?: boolean;
  source?: 'push' | 'local';
}

@Injectable({
  providedIn: 'root',
})
export class NotificationStorageService {
  private readonly MAX_NOTIFICATIONS = 100;

  constructor(private vaultService: VaultService) {}

  async saveNotifications(notifications: StoredNotification[]): Promise<void> {
    try {
      const notificationsToStore = notifications.slice(0, this.MAX_NOTIFICATIONS);
      await this.vaultService.setKeyValue(STORED_NOTIFICATIONS, JSON.stringify(notificationsToStore));
    } catch {}
  }

  async loadNotifications(): Promise<StoredNotification[]> {
    try {
      const value = await this.vaultService.getKeyValue(STORED_NOTIFICATIONS);
      if (value) {
        const notifications = JSON.parse(value);
        return notifications.map((notif: any) => ({
          ...notif,
          receivedAt: new Date(notif.receivedAt),
        }));
      }
      return [];
    } catch {
      return [];
    }
  }

  async clearNotifications(): Promise<void> {
    try {
      await this.vaultService.setKeyValue(STORED_NOTIFICATIONS, '');
    } catch {}
  }
}
